import {TreemapChart, PieChart, BarChart, LineChart, HeatmapChart, ScatterChart, RadarChart} from "echarts/charts";
import {
    TooltipComponent,
    LegendComponent,
    GridComponent,
    GraphicComponent,
    MarkAreaComponent,
    MarkLineComponent,
    MarkPointComponent,
    VisualMapComponent,
    RadarComponent,
} from "echarts/components";
import * as echarts from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import ReactEChartsCore from "echarts-for-react/lib/core";
import {useRef, useCallback} from "react";

import type {EChartsOption} from "echarts";

// Register only the components we need
echarts.use([
    TreemapChart,
    PieChart,
    BarChart,
    LineChart,
    HeatmapChart,
    ScatterChart,
    RadarChart,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    GraphicComponent,
    MarkAreaComponent,
    MarkLineComponent,
    MarkPointComponent,
    VisualMapComponent,
    RadarComponent,
    CanvasRenderer,
]);

interface EChartsCardProps {
    option: EChartsOption;
    height?: number;
    loading?: boolean;
    onEvents?: Record<string, (params: unknown) => void>;
}

export function EChartsCard({
    option,
    height = 300,
    loading = false,
    onEvents,
}: EChartsCardProps) {
    const chartRef = useRef<ReactEChartsCore>(null);

    const defaultEvents = useCallback(() => {
        const events: Record<string, (params: unknown) => void> = {};
        if (!onEvents?.click) {
            events.click = (params: unknown) => {
                console.log("[EChartsCard] click:", params);
            };
        }
        return {...events, ...onEvents};
    }, [onEvents]);

    if (loading) {
        return (
            <div
                className="flex items-center justify-center bg-gray-50 rounded"
                style={{height}}
                data-testid="echarts-loading"
            >
                <span className="text-xs text-gray-400">Loading chart...</span>
            </div>
        );
    }

    return (
        <div data-testid="echarts-card">
            <ReactEChartsCore
                ref={chartRef}
                echarts={echarts}
                option={option}
                style={{height, width: "100%"}}
                notMerge
                lazyUpdate
                onEvents={defaultEvents()}
            />
        </div>
    );
}
